import {mapMutations, Module} from "vuex";
import {RootState} from "@/store/types";
import {LoadingState} from "@/store/Loading/types";

const LoadingModule: Module<LoadingState, RootState> = {
    namespaced: true,
    state: {
        loadingModal: 0
    },
    getters: {
        getLoadingStatus(state){
            return state.loadingModal;
        }
    },
    mutations: {
        increaseLoadingModal(state){
            state.loadingModal++;
        },
        decreaseLoadingModal(state){
            if(state.loadingModal > 0) {
                state.loadingModal--;
            }else{
                state.loadingModal = 0;
            }
        }
    },
    actions: {
        showLoadingModal({commit}){
            commit("increaseLoadingModal");
        },
        hideLoadingModal({commit}){
            commit("decreaseLoadingModal");
        }
    }
}

export default LoadingModule;

